import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ScrollToService} from '@services/scroll-to.service';
import {Subscription} from 'rxjs';
import {WindowEventsService} from '@services/window-events.service';

@Component({
    selector: 'app-anchor-navigation',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ul class="page-inside-navigation">
            <li class="page-inside-navigation__title">Разделы</li>
            <li *ngFor="let item of items" (click)="onItemClick(item)" [class._active]="item.active">
                <a href="javascript:;"><ng-container *ngIf="item.active">→&nbsp;</ng-container>{{item.title}}</a>
            </li>
        </ul>
    `,
    providers: [
    ]
})

export class AnchorNavigationComponent implements OnInit, OnChanges, OnDestroy {
    @Input() items: AnchorNavigationItem[] = [];

    private subs: Subscription[] = [];

    private targetIds: string[] = [];

    constructor(
        private cd: ChangeDetectorRef,
        private windowEvents: WindowEventsService,
    ) {}

    ngOnInit() {
        this.subs.push(
            this.windowEvents.visibleElementId$.subscribe((v) => this.setActive(v)),
        );
    }

    ngOnChanges() {
        this.targetIds = this.items.map(item => item.anchor);
        /**
         * В любой непонятной ситуации делаем первый пункт активным - и по дефолту и если что-то в фоне изменяется
         */
        this.setFirstActive();
    }

    onItemClick(item: AnchorNavigationItem) {
        ScrollToService.toById(item.anchor);
        this.setActive(item.anchor);
    }

    private setActive(anchor: string) {
        if (this.targetIds.indexOf(anchor) >= 0) {
            this.items.forEach(a => a.active = a.anchor === anchor);
        } else {
            this.setFirstActive();
        }
        this.cd.detectChanges();
    }

    private setFirstActive() {
        if (this.items.length) {
            this.items.forEach((item, index) => item.active = index === 0);
        }
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}

export interface AnchorNavigationItem {
    title: string;
    anchor: string;
    active?: boolean;
}
